/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PianificazioneResDto } from '../../models/pianificazione-res-dto';
import { UpdatePianificazioneDto } from '../../models/update-pianificazione-dto';

export interface PianificazioniControllerUpdatePianificazione$Params {
  idPianificazione: number;
  body: UpdatePianificazioneDto;
}

export function pianificazioniControllerUpdatePianificazione(
  http: HttpClient,
  rootUrl: string,
  params: PianificazioniControllerUpdatePianificazione$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PianificazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    pianificazioniControllerUpdatePianificazione.PATH,
    'patch',
  );
  if (params) {
    rb.path('idPianificazione', params.idPianificazione, {});
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PianificazioneResDto>;
      }),
    );
}

pianificazioniControllerUpdatePianificazione.PATH =
  '/admin/pianificazioni/id/{idPianificazione}';
